import {StrictMode, Suspense} from "react";
import ReactDOM from 'react-dom';
import App from './App';
import {ConfigProvider} from 'antd';
import {Provider} from 'react-redux';
import {reduxStore} from "./services/redux/ReduxIndex";
import trTR from 'antd/es/locale-provider/tr_TR';
import reportWebVitals from './reportWebVitals';


//!INFO global css eklenme alanı
import "./App.scss";

//!INFO çoklu dil yapısını import edelim
import './i18n';

let antdLocale = trTR;

ReactDOM.render(
    <StrictMode>
        <Provider store={reduxStore}>
            <ConfigProvider locale={antdLocale}>
                <Suspense fallback="">
                    <App/>
                </Suspense>
            </ConfigProvider>
        </Provider>
    </StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
